export default function(stringDate, language = "pl") {
  const date = new Date(stringDate);
  return date.toLocaleString(language, { weekday: "long" });
}
